/* eslint-disable import/no-anonymous-default-export, react/display-name -- decisionId=IRV3-DECISION-AUDIT-ROUTE-COMPANIONS expiresAt=2026-06-30 file=frontend/app/(public)/iletisim/error.tsx line=1 reason=next_route_companion_default */
"use client";

import Link from "next/link";

export default function () {
  return (
    <div className="min-h-screen bg-slate-50 px-4 py-24">
      <div className="mx-auto max-w-xl rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-sm">
        <h1 className="text-2xl font-semibold text-slate-950">
          İletişim sayfası açılamadı
        </h1>
        <p className="mt-3 text-sm leading-6 text-slate-600">
          Lütfen sayfayı yenileyin. Sorun devam ederse WhatsApp üzerinden IKAI
          ekibine ulaşabilirsiniz.
        </p>
        <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:justify-center">
          <Link
            href="/iletisim"
            className="rounded-xl bg-indigo-600 px-5 py-3 text-sm font-semibold text-white transition hover:bg-indigo-700"
          >
            Tekrar dene
          </Link>
          <a
            href="https://wa.me/19129224004?text=Merhaba,%20IKAI%20ileti%C5%9Fim%20sayfas%C4%B1nda%20sorun%20ya%C5%9F%C4%B1yorum."
            target="_blank"
            rel="noopener noreferrer"
            className="rounded-xl border border-slate-300 bg-white px-5 py-3 text-sm font-semibold text-slate-900 transition hover:bg-slate-50"
          >
            WhatsApp'tan yaz
          </a>
        </div>
      </div>
    </div>
  );
}
